// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { Subscription } from 'rxjs';

// --- 3rd Party
import moment from 'moment';

// --- HS Code
import { LanguageModel } from '../../../models';

// #endregion

@Injectable({
  providedIn: 'root'
})
export abstract class LanguageDomBaseService {

  protected _langChangeSubscription: Subscription = Subscription.EMPTY;

  constructor(protected document: Document) {}

  abstract init(): void;

  protected onLangChange(language: LanguageModel, isMobileUser: boolean): void {
    if (language) {
      this.document.documentElement.lang = isMobileUser ? 'en' : language.isoTwoLetterName;
      this.document.documentElement.dir = isMobileUser ? 'ltr' : (language.isRtl ? 'rtl' : 'ltr');
      const translateLanguageAndCulture = language.cultureCode !== null ?
      `${language.isoTwoLetterName}-${language.cultureCode}` :
      `${language.isoTwoLetterName}`;
      moment.locale(isMobileUser ? 'en-GB' : translateLanguageAndCulture);
    }
  }

  public destroy(): void {
    if (this._langChangeSubscription) {
      this._langChangeSubscription.unsubscribe();
      this._langChangeSubscription = Subscription.EMPTY;
    }
  }
}
